export { default } from './Offers';
